import "./CreateGameOptionButton.css";
import newsieLogo from "../../../../../Assets/newsie-triumphant-192-removebg.png";
import wordsearchLogo from 'Assets/Games/wordsearch-logo.png'
import quizLogo from 'Assets/Games/quiz.png'
import crossswordLogo from 'Assets/Games/crossword-logo.png'


const gameToAssetMap = {
  newsie: {
    title: 'Newsie',
    logo: newsieLogo
  },
  wordsearch: {
    title: 'Wordsearch',
    logo: wordsearchLogo
  },
  crossword: {
    title: 'Crossword',
    logo: crossswordLogo
  },
  quiz: {
    title: 'Quiz',
    logo: quizLogo
  }
};


const CreateGameOptionButton = (props) => {
  const { game, onSelectGameType, justIcon } = props;
  const {logo, title} = gameToAssetMap[game];
  
  return (
    <div
      className={`create-game-option-button-container ${justIcon ? 'just-icon' : ''}`}
      name={`create-game-${game}`}
      onClick={() => onSelectGameType(game)}
    >
      <div className="create-game-option-button-img-container">
        <img src={logo} style={{ width: "100%", height: "100%" }} />
      </div>
      {!justIcon ? <div className="create-game-option-button-label">{title}</div> :  null}
    </div>
  );
};

export default CreateGameOptionButton;
